import { render, staticRenderFns } from "./handoverDetail.vue?vue&type=template&id=da97be5a&"
import script from "./handoverDetail.vue?vue&type=script&lang=js&"
export * from "./handoverDetail.vue?vue&type=script&lang=js&"
import style0 from "./handoverDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports